import { forwardRef, useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const FormDescription = forwardRef(({ value, onChange }, ref) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    if (!quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        theme: "snow",
        placeholder: "Escreva uma descrição",
      });

      // Expõe a instância do Quill para o componente pai
      if (ref) {
        ref.current = quillRef.current;
      }

      quillRef.current.on("text-change", () => {
        onChange?.(quillRef.current.root.innerHTML);
      });
    }

    // Sincroniza valor externo com o editor
    if (value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value || "";
    }
  }, [value, onChange, ref]);

  return (
    <div className="form__description">
      <div ref={editorRef} className="description__editor" />
      <label>Descrição</label>
    </div>
  );
});

export default FormDescription;
